import React from 'react';
import PropTypes from 'prop-types';
import BoardMember from 'components/BoardMember';
import './InvestorBoardMembersBlock.scss';

const InvestorBoardMembersBlock = ({ heading, items, anchorId, lang }) => {
    return (
        <div className="investor-board-members-block" id={anchorId}>
            <div className="investor-board-members-block__container">
                {heading && <h2 className="investor-board-members-block__heading">{heading}</h2>}
                {items && items.length > 0 ? (
                    <ul className="investor-board-members-block__list">
                        {items.map((item, key) => (
                            <li key={key} className="investor-board-members-block__item">
                                <BoardMember
                                    {...item}
                                    // BE: Recommended BoardMember image size: 884x628px
                                    downloadImageLabel={lang.downloadImageLabel}
                                    className="board-member_in-investor-board"
                                />
                            </li>
                        ))}
                    </ul>
                ) : null}
            </div>
        </div>
    );
};

InvestorBoardMembersBlock.propTypes = {
    heading: PropTypes.string,
    anchorId: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape(BoardMember.propTypes)),
    lang: PropTypes.shape({
        downloadImageLabel: PropTypes.string.isRequired,
    }).isRequired,
};

export default InvestorBoardMembersBlock;


// WEBPACK FOOTER //
// ./src/components/InvestorBoardMembersBlock/InvestorBoardMembersBlock.jsx